import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

/** Store hub toolbar select — custom chevron, no native arrow overlap. */
export default function HubFilterSelect({
  value,
  onChange,
  isDarkMode,
  className = '',
  children,
  'aria-label': ariaLabel,
}) {
  return (
    <div className={`relative ${className}`}>
      <select
        value={value}
        onChange={onChange}
        aria-label={ariaLabel}
        className={`appearance-none w-full cursor-pointer text-sm rounded-lg border pl-3 pr-9 py-2.5 leading-snug ${
          isDarkMode
            ? 'bg-slate-950 border-slate-700 text-slate-200'
            : 'bg-white border-slate-300 text-slate-800 shadow-sm'
        } focus:outline-none focus:ring-2 focus:ring-orange-500/30 focus:border-orange-400/60`}
      >
        {children}
      </select>
      <ChevronDownIcon
        aria-hidden
        className={`pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 ${
          isDarkMode ? 'text-slate-500' : 'text-slate-400'
        }`}
      />
    </div>
  );
}
